export default class ConfigService {
	private config: object;

	constructor(config: object) {
		this.config = config;
	}
}